import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    CustomShipViaAccountNumberActions,
    CustomShipViaAccountNumberState,
} from "@tsesco/Store/CheckoutReviewAndSubmitCarrierService/CheckoutReviewAndSubmitReducer";
import { Handler } from "@tsesco/Types/SEHandlerCreator";

interface Parameter {
    collectAccountNumber: string;
}

type HandlerType = Handler<Parameter, Parameter, CustomShipViaAccountNumberActions, CustomShipViaAccountNumberState>;

export const DispatchShipViaAccountNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmitCarrierService/UpdateShipViaAccountNumber",
        shipViaAccountNumber: props.parameter.collectAccountNumber,
    });
};

export const chain = [DispatchShipViaAccountNumber];

const sendShipViaAccountNumberHandler = createHandlerChainRunner(chain, "SendShipViaAccountNumber");
export default sendShipViaAccountNumberHandler;
